import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=1b6e3d1a&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts&"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=1b6e3d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e3d1a",
  null
  
)

export default component.exports